<template>
  <hm-content title="商品列表">
    <div class="table-panel flex flex-between">
      <div class="mr10">
        <el-button type="primary" size="small" @click="addGoods"
          >新建商品</el-button
        >
        <el-button type="primary" size="small" @click="importTempVisible = true"
          >商品导入</el-button
        >
      </div>
      <div class="flex-1 text-right">
        <el-cascader
          v-model="searchCondition.categoryId"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="categoryFunc"
          clearable
          placeholder="请选择类目"
        ></el-cascader>
        <el-cascader
          v-model="searchCondition.attributeId"
          placeholder="请选择辅助属性"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="attributeFunc"
          clearable
        ></el-cascader>
        <el-select
          v-model="searchCondition.platFormId"
          placeholder="请选择销售渠道"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="无平台" value="isWxshop"></el-option>
          <el-option
            :label="v.platformName"
            :value="v.platformId"
            v-for="(v, i) in salesChannels"
            :key="i"
          ></el-option>
        </el-select>

        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.keyWords"
          size="small"
          :placeholder="placeholder"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width:100px"
            @change="selectQueryType"
            v-model="searchCondition.queryType"
          >
            <el-option label="商品名" value="spu_name"></el-option>
            <el-option label="货号" value="goods_sn"></el-option>
            <el-option label="条码" value="spec_barcode"></el-option>
            <el-option label="品牌名" value="brand_name"></el-option>
          </el-select>
        </el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output(allMallGoodsList, 'brandTable', '商品列表')"
          :loading="isOutputing"
          >导出</el-button
        >
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="flex batch flex-between">
        <div>
          <span>已选{{ num }}条</span>
        </div>
        <div @click="batchSetting">
          <span class="delete-icon hmicon icon-xitong"></span>
          批量设置
        </div>
        <!-- <div @click="batchDelete">
          <span class="delete-icon hmicon icon-shanchu"></span>删除
        </div> -->
      </div>
      <el-table
        stripe
        border
        ref="brandTable"
        @selection-change="getChecked"
        :data="mallGoodsList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="商品名称"
          width="300"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="250"
          prop="goodsSnAndBarcode"
          show-overflow-tooltip
          label="商品编码/条码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="商品类目(所属末级)"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="isOverseas"
          label="是否一品多码"
        >
          <template slot-scope="scope">
            {{ scope.row.isMultCodes === "true" ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="salePlatForms"
          label="销售渠道"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="salesStateFormat"
          label="状态"
        >
          <template slot-scope="scope">
            <span
              class="status danger"
              v-show="scope.row.salesState === 'close'"
              >停售</span
            >
            <span
              class="status success"
              v-show="scope.row.salesState === 'open'"
              >可售</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="supplierName"
          label="供货商"
        >
          <template slot-scope="scope">
            {{
              scope.row.supplierName === null ? "自营" : scope.row.supplierName
            }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
          width="140"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <div class="pointer mr10" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <!-- <el-tooltip
                class="item"
                 
                content="删除"
                placement="top"
              >
                <div class="pointer mr10" @click="remove(scope.row)">
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="mallGoodsList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible">
      <div slot="title">
        <span class="mr10">批量设置</span>
        <span class="form-item-tip">已选商品数量{{ checkedRow.length }}个</span>
      </div>
      <div class="flex tabs">
        <el-form label-width="100px">
          <el-form-item label="原有文字">
            <el-input
              size="small"
              type="text"
              v-model.trim="batchCondition.oldWord"
            ></el-input>
          </el-form-item>
          <el-form-item label="替换为">
            <el-input
              size="small"
              type="text"
              v-model.trim="batchCondition.newWord"
            ></el-input>
          </el-form-item>
          <el-form-item label="修改分类为">
            <el-cascader
              v-model="batchCondition.categoryId"
              :show-all-levels="false"
              size="small"
              class="mr10"
              :props="categoryFunc"
              clearable
              placeholder="请选择类目"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="销售状态">
            <el-switch
              v-model="batchCondition.salesState"
              active-text="可售"
              inactive-text="停售"
              active-value="open"
              active-color="#13ce66"
              inactive-value="close"
            ></el-switch>
          </el-form-item>
          <el-form-item label="批量发布到">
            <el-select
              clearable
              multiple
              v-model="batchCondition.spuPlatFormList"
              placeholder="请选择销售渠道"
              size="small"
              filterable
              class="mr10"
            >
              <el-option
                :label="v.platformName"
                :value="v.platformId"
                v-for="(v, i) in salesChannels"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitRuleForm" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small" type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <hm-import-temp
      :tHeader="tHeader"
      :tBody="tBody"
      @close="importTempVisible = false"
      @importSuccess="importSuccess"
      title="商品导入"
      filterText="spuName"
      :visible="importTempVisible"
    ></hm-import-temp>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { outPutMixin } from "@/mixins/outputMixin";
import HmImportTemp from "@/components/HmImportTemp";
import { setCookie, getCookie } from "@/utils/utils";

export default {
  components: { HmImportTemp },
  mixins: [outPutMixin],
  data() {
    return {
      tHeader: [
        "商品名称",
        "商品货号",
        "商品条码",
        "建议零售价",
        "最低可售价",
        "商品净重",
        "商品毛重",
        "商品重量单位（仅支持输入kg或g）",
        "规格ID(仅一品多码用，英文逗号分隔)"
      ],
      tBody: [
        "spuName",
        "goodsSn",
        "spuBarcode",
        "recommendedRetailPrice",
        "basePrice",
        "netWeight",
        "grossWeight",
        "weightUnit",
        "valueId"
      ],
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: [],
      batchCondition: {
        oldWord: "",
        newWord: "",
        categoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      placeholder: "请输入商品名",
      searchCondition: {
        queryType: "spu_name",
        platFormId: ""
      },
      activityChildCategoryList: [],
      currentPage: 1,
      num: 0,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false,
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  created() {
    this.getParamsCookie();
  },
  mounted() {
    if (this.$route.query.categoryId) {
      this.searchCondition.categoryId = [this.$route.query.categoryId];
    }
    this.$store.dispatch("querySalesChannels").then(res => {
      if (res.result.length) {
        this.searchCondition.platFormId = res.result[0].platformId;
        this.queryList();
      } else {
        this.searchCondition.platFormId = "isWxshop";
        this.queryList();
      }
    });
  },
  computed: mapGetters(["mallGoodsList", "salesChannels", "allMallGoodsList"]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  methods: {
    // 导出excel
    // output(data, funcName, title) {
    //   require.ensure([], () => {
    //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
    //     this.isOutputing = true;
    //     const func = this[funcName];
    //     func()
    //       .then(res => {
    //         const list = res;
    //         list.forEach(v => {
    //           if (v.deliveryType === "mdzt") {
    //             v.deliveryType = "门店自提";
    //           } else if (v.deliveryType === "kdfh") {
    //             v.deliveryType = "快递发货";
    //           } else if (v.deliveryType === "tcps") {
    //             v.deliveryType = "同城配送";
    //           }
    //         });
    //         const tHeader = this.$refs.table.columns
    //           .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
    //           .filter(o => o);

    //         let filterVal = [];
    //         if (list.length > 0) {
    //           filterVal = this.$refs.table.$children
    //             .map(o => o._props.prop)
    //             .filter(o => o);
    //         }
    //         const data = this.formatJson(filterVal, list);
    //         exportJsonToExcel(
    //           tHeader,
    //           data,
    //           title + new Date().toLocaleString()
    //         );
    //         this.isOutputing = false;
    //       })
    //       .catch(() => {
    //         this.isOutputing = false;
    //       });
    //   });
    // },
    selectQueryType(queryType) {
      if (queryType === "spuName") {
        this.placeholder = "请输入商品名";
      } else if (queryType === "goodsSn") {
        this.placeholder = "请输入货号";
      } else if (queryType === "specBarcode") {
        this.placeholder = "请输入条码";
      } else if (queryType === "brandName") {
        this.placeholder = "请输入品牌名";
      }
    },
    importSuccess(spuBoList) {
      this.$store
        .dispatch("importGoods", {
          spuBoList: spuBoList
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.importTempVisible = false;
            this.queryList();
          }
        });
    },
    submitRuleForm() {
      let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
      batchCondition.categoryId =
        batchCondition.categoryId[batchCondition.categoryId.length - 1];
      batchCondition.spuIdList = this.checkedRow;
      this.$store.dispatch("batchEdit", batchCondition).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
          this.dialogVisible = false;
        }
      });
    },
    addGoods() {
      this.$router.push({ name: "AddGoods" });
    },

    edit(row) {
      this.$router.push({
        name: "EditGoods",
        query: {
          spuId: row.spuId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          spuId: row.spuId
        };
        if (type) {
          actionName = "batchEdit";
          params = {
            spuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: queryAll ? 1 : this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      if (searchCondition.platFormId === "isWxshop") {
        searchCondition.platFormId = "";
        searchCondition.isWxshop = "yes";
      }

      Object.assign(params, searchCondition);
      this.setParamsCookie();
      const actionName = queryAll
        ? "queryAllMallGoodsList"
        : "queryMallGoodsList";
      return this.$store.dispatch(actionName, params);
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
      this.num = selection.length;
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.remove(this.checkedRow, "batch");
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    setParamsCookie() {
      setCookie({
        key: "goodsLibParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "goodsLibParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}

.tabs {
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .tips {
    color: #666;
    font-size: 12px;
    padding-left: 10px;
  }
}
.tips {
  color: #999;
  font-size: 14px;
}
</style>
